import { render } from "./ArchiveDetailView.vue?vue&type=template&id=39bcae02"
import script from "./ArchiveDetailView.vue?vue&type=script&lang=js"
export * from "./ArchiveDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__